import { requestAgencyIfNeeded } from "hiringagent-dashboard/actions/agency";
import { agencySliceSelector } from "hiringagent-dashboard/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector("WithAgency", agencySliceSelector, {
  onLoad: requestAgencyIfNeeded,
});
